import { maxLength, required } from '../../utils/validation';
import { extractFoobarReference } from '../../utils/foobar';

export const SiteValidations = {
  name: [required('models.site.name'), maxLength(24, 'models.site.name')]
};

class Serializer {
  normalize = data => {
    return {
      id: data.id,
      name: data.value,
      href: data.self.href,
      account: data.account && {
        id: extractFoobarReference(data.account),
        href: data.account.href
      },
      areaCount: +(data.assetInfo.metadata.props.areaCount || 1),
      labels: {
        tag: data.assetInfo.metadata.props.tag_label,
        group: data.assetInfo.metadata.props.group_label,
        category: data.assetInfo.metadata.props.category_label,
        field1: data.assetInfo.metadata.props.field1_label,
        field2: data.assetInfo.metadata.props.field2_label
      }
    };
  };
  serialize = site => {
    return {
      configValue: site.name,
      properties: {organizationId: site.organizationId}
    };
  };
  serializeEdit = site => {
    return {
      name: site.name
    };
  };
  serializeLabels = site => {
    return {
      tag_label: site.labels.tag || null,
      group_label: site.labels.group || null,
      category_label: site.labels.category || null,
      field1_label: site.labels.field1 || null,
      field2_label: site.labels.field2 || null
    };
  };
}

export const SiteSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/site/index.js